import React from 'react';
import StyledSelect from '../../components/StyledSelect';
import { TONE_ESTILO, TONE_TOM, TONE_EMOJIS, TONE_LINGUAGEM } from './trainAgentConstants';
import { blockStyle, labelStyle } from './trainAgentStyles';

export function TrainAgentToneBlock({ vm }) {
  const { tone, setTone } = vm;
  return (
    <div style={blockStyle}>
      <label style={labelStyle}>3. Estilo de Atendimento (tone)</label>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '12px' }}>
        <div>
          <label style={{ ...labelStyle, fontSize: '11px' }}>Estilo</label>
          <StyledSelect
            value={tone.estilo}
            onChange={(v) => setTone((prev) => ({ ...prev, estilo: v }))}
            options={TONE_ESTILO}
            placeholder="— Selecione —"
          />
        </div>
        <div>
          <label style={{ ...labelStyle, fontSize: '11px' }}>Tom</label>
          <StyledSelect
            value={tone.tom}
            onChange={(v) => setTone((prev) => ({ ...prev, tom: v }))}
            options={TONE_TOM}
            placeholder="— Selecione —"
          />
        </div>
        <div>
          <label style={{ ...labelStyle, fontSize: '11px' }}>Emojis</label>
          <StyledSelect
            value={tone.emojis}
            onChange={(v) => setTone((prev) => ({ ...prev, emojis: v }))}
            options={TONE_EMOJIS}
            placeholder="— Selecione —"
          />
        </div>
        <div>
          <label style={{ ...labelStyle, fontSize: '11px' }}>Linguagem</label>
          <StyledSelect
            value={tone.tipoLinguagem}
            onChange={(v) => setTone((prev) => ({ ...prev, tipoLinguagem: v }))}
            options={TONE_LINGUAGEM}
            placeholder="— Selecione —"
          />
        </div>
        <div>
          <label style={{ ...labelStyle, fontSize: '11px' }}>Temperatura (0 = consistente, 1 = criativo)</label>
          <input
            type="range"
            min={0}
            max={1}
            step={0.1}
            value={tone.temperatura}
            onChange={(e) => setTone((prev) => ({ ...prev, temperatura: parseFloat(e.target.value) }))}
            style={{ width: '100%' }}
          />
          <span style={{ color: '#B0BEC5', fontSize: '12px' }}>{tone.temperatura}</span>
        </div>
      </div>
    </div>
  );
}
